
//Función para calcular los tonos de los colores para la paleta en función al color primario.
export const colorsCalculator = (color) => {

    //console.log("se seleccionó un color: ", color);
    if (color) { //Si seleccionó un color.

        //Operaciones para degradado claros en formato RGB.
        let red_ligth = color.rgb.r + 70; //Sacar el parámetro de red para el degradado.
        let green_ligth = color.rgb.g + 70; //Sacar el parámetro de green para el degradado.
        let blue_ligth = color.rgb.b + 70; //Sacar el parámetro de blue para el degradado.
        let rgb_ligth = { a: 1, b: blue_ligth, g: green_ligth, r: red_ligth }; //El nuevo objeto con los valores de RGB.

        //Operaciones para la burbuja de mensajes claros en formato RGB.
        let red_msg = color.rgb.r + 70; //Sacar el parámetro de red para el degradado.
        let green_msg = color.rgb.g + 70; //Sacar el parámetro de green para el degradado.
        let blue_msg = color.rgb.b + 70; //Sacar el parámetro de blue para el degradado.
        let rgb_msg = { a: 1, b: blue_msg, g: green_msg, r: red_msg }; //El nuevo objeto con los valores de RGB.

        //Operaciones para color oscuro en formato RGB.
        let red_dark = color.rgb.r - 50; //Sacar el parámetro de red para el degradado.
        let green_dark = color.rgb.g - 50; //Sacar el parámetro de green para el degradado.
        let blue_dark = color.rgb.b - 50; //Sacar el parámetro de blue para el degradado.
        let rgb_dark = { a: 1, b: blue_dark, g: green_dark, r: red_dark }; //El nuevo objeto con los valores de RGB.

        //Operaciones para color hover dark en formato RGB.
        let red_hover = color.rgb.r - 90; //Sacar el parámetro de red para el degradado.
        let green_hover = color.rgb.g - 90; //Sacar el parámetro de green para el degradado.
        let blue_hover = color.rgb.b - 90; //Sacar el parámetro de blue para el degradado.
        let rgb_hover = { a: 1, b: blue_hover, g: green_hover, r: red_hover }; //El nuevo objeto con los valores de RGB.
        
        //Objeto con la paleta de colores final.
        let newColor = { bg: color.hex, bg_dark: rgb_dark, degraded: rgb_ligth, hover: rgb_hover, message: rgb_msg };
        return newColor
    }

};